import React from "react";

import { Line } from "react-chartjs-2"; 
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";

import "../components/css/SalesChart.css";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SalesChart = ({ salesTrend }) => {

    if (!salesTrend || salesTrend.length === 0) {
        return (
            <div className="salesChartDiv">
                <div className="loading-placeholder">
                    <p>Loading sales data... Please wait.</p>
                </div>
            </div>
        );
    }

    const dates = salesTrend.map(e => {
        const [year, month, day] = e.sales_date.split("-");
        const date = new Date(`${year}-${month}-${day}`);
        return `${day} ${date.toLocaleString("en-US", { month: "short" })}`;
    });
    const newDates = [...new Set(dates)];
    const machines = [...new Set(salesTrend.map(item => item.machineUUID))]

    const maxLabels = 4;
    const topMachines = machines.slice(0, maxLabels);
    const otherMachines = machines.slice(maxLabels);

    const chartColors = {
        red: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-red").trim(),
        blue: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-blue").trim(),
        yellow: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-yellow"),
        green: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-green").trim(),
        purple: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-purple").trim(),
        orange: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-orange").trim(),
        borderRed: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-red").trim(),
        borderBlue: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-blue").trim(),
        borderYellow: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-yellow").trim(),
        borderGreen: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-green").trim(),
        borderPurple: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-purple").trim(),
        borderOrange: getComputedStyle(document.documentElement).getPropertyValue("--chart-color-border-orange").trim(),
    };

    const backgroundColors = [
        chartColors.red, 
        chartColors.blue, 
        chartColors.yellow,
        chartColors.green, 
        chartColors.purple, 
        chartColors.orange
    ];

    const borderColors = [
        chartColors.borderRed,
        chartColors.borderBlue,
        chartColors.borderYellow,
        chartColors.borderGreen, chartColors.borderPurple, chartColors.borderOrange
    ];

    const salesDataMap = {};

    machines.forEach(machine => {
        salesDataMap[machine] = {};
        newDates.forEach(date => {
            salesDataMap[machine][date] = 0;
        });
    });

    salesTrend.forEach(({ sales_date, machineUUID, total_amount }) => {
        const [year, month, day] = sales_date.split("-");
        const date = new Date(`${year}-${month}-${day}`);
        const formattedDate = `${day} ${date.toLocaleString("en-US", { month: "short" })}`;
        
        salesDataMap[machineUUID][formattedDate] = total_amount ?? 0;
    });

    const datasets = topMachines.map((machine, index) => ({
        label: machine,
        data: newDates.map(date => (salesDataMap[machine][date])),
        backgroundColor: backgroundColors[index % backgroundColors.length],
        borderColor: borderColors[index % borderColors.length],
        borderWidth: 1,
        pointStyle: "dash"
    }));

    if(machines.length > maxLabels) {
        const otherMachinesData = newDates.map(date => {
            const total = otherMachines.reduce((sum, machine) => {
                if (
                    salesDataMap.hasOwnProperty(machine) &&
                    salesDataMap[machine].hasOwnProperty(date)
                ) {
                    const value = parseFloat(salesDataMap[machine][date]);
                    return sum + (isNaN(value) ? 0 : value);
                } else {
                    return sum;
                }
            }, 0);
            return Math.round(total * 100) / 100;
        });

        datasets.push({
            label: "Other",
            data: otherMachinesData,
            backgroundColor: "lightgray",
            borderColor: "darkgray",
            borderWidth: 1,
            pointStyle: "dash"
        });
    }

    const data = {
        labels: newDates,
        datasets
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                // position: "right",
                // align: "end",
                title: {
                    display: true,
                    text: "Date(s)",
                    color: "gray",
                    textAlign: "right",
                },
            },
            y: {
                // position: "top",
                // align: "start",
                title: {
                    display: true,
                    text: "Sales",
                    color: "gray",
                    textAlign: "left",
                },
            },
        },
        plugins: {
            legend: {
                position: "right",
                labels: {
                    boxWidth: 20,
                    boxHeight: 20,
                    padding: 10,
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
                onClick: (e) => e.native.stopPropagation(),
            },
            tooltip: {
                enabled: true,
            },
        },
    };


    return(
        <>
            <div className="salesChartDiv">
                <div className="chart-wrapper">
                    <Line data={data} options={options} />
                </div>
            </div>
        </>
    )
}

export default SalesChart;